import { createContext, useContext, useState, useCallback, useMemo } from 'react'

const NavigationContextIdentityContext = createContext(null)

export function NavigationContextIdentityProvider({ navKey, route, children }) {
  const [tabKey, setTabKey] = useState(null)

  const setTabKeyForPage = useCallback((key, forNavKey) => {
    if (forNavKey === navKey) setTabKey(key)
  }, [navKey])

  const value = useMemo(() => ({
    route,
    nav_key: navKey,
    tab_key: tabKey,
    setTabKey: (key) => setTabKeyForPage(key, navKey),
  }), [route, navKey, tabKey, setTabKeyForPage])

  return (
    <NavigationContextIdentityContext.Provider value={value}>
      {children}
    </NavigationContextIdentityContext.Provider>
  )
}

export const useNavigationContextIdentity = () => useContext(NavigationContextIdentityContext)

export function useReportTabKey(activeTab) {
  const ctx = useContext(NavigationContextIdentityContext)
  const setTabKey = ctx?.setTabKey
  const navKey = ctx?.nav_key
  if (setTabKey && navKey) setTabKey(activeTab)
}
